<template>
  <div class="">
    <Card class="">
      <template #title> Rollerin Yetki Yerleri </template>
      <template #content>
        <div class="grid fluid formgrid">
          <div class="col-3">
            <div class="col-12">
                <Listbox v-model="SelectedRol" class="w-full" dataKey="Rol_rowid" :options="Roller"
                  optionLabel="RolAd" placeholder="Rol Seç .." :maxSelectedLabels="1" listStyle="height:270px"
                  :virtualScrollerOptions="{ itemSize: 5 }" filter />
              </div>

              <div class="col-12 mt-3">
                <Button label="Getir" @click="butonclick(data)" class="w-full h-4rem" />
              </div>
          </div>
          <div class=" col-9">
            <Card class="">
              <template #content>
                <DataTable v-if="DataTable_render" :columns="columns" :data="YetkiYerleriListesi"
                  v-on:set-child-data="getDataChild" />
              </template>
            </Card>
          </div>
        </div>
      </template>
    </Card>

    <Dialog v-model:visible="YetkiModal" :breakpoints="{ '960px': '75vw', '640px': '100vw' }" :style="{ width: '25vw' }"
      :modal="true">
      <template #header>
        <h4>Yetki Değiştir</h4>
      </template>
      <div class="grid fluid formgrid">
        <div class="field col-6">
            <Button label="Yetkilendir" icon="pi pi-refresh" size="large" severity="success" raised @click="this.Yetkilendir()" class="w-full"/>
        </div>
        <div class="field col-6">
            <Button label="Yetki Kaldır" icon="pi pi-replay" size="large" severity="danger" raised @click="this.YetkiKaldir()" class="w-full"/>
        </div>
      </div>

      <Divider />
      <div class="flex justify-content-end flex-wrap">
        <Button class="m-1" label="Kapat" icon="pi pi-times" iconPos="right" size="small" severity="danger" @click="this._YetkiModal()" />
      </div>
    </Dialog>

  </div>
</template>

<script>
import { useVuelidate } from "@vuelidate/core";
import GlobalServis from "../../../../../services/GlobalServis";
import DataTable from "../../DataTable/DataTable.vue";

export default {
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      YetkilendirButton: false,
      YetkiKaldirButton: false,
      //
      YetkiModal: false,
      DataTable_render: true,
      //
      Roller: [],
      SelectedRol: null,
      SelectedRol_rowid: 1,
      //
      YetkiYerleriListesi: [],
      YetkiYeri_rowid: null,
      //
      columns: [
        { field: "Ad", header: "Yetki Yeri Adı" },
      ],
    };
  },
  methods: {
    // eslint-disable-next-line
    butonclick(data) {

      this.SelectedRol_rowid = this.SelectedRol.Rol_rowid
      this._GetRolYetkiYerleri();
    },
    InitService() {

      this.SelectedRol = {
        RolAd: "Admin",
        Rol_rowid: 1
      }

      GlobalServis.GlobalServis("GET", "GetRolTablosu", "").then((res) => {
        if (res.status == 200) {
          this.Roller = res.data;
        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    _GetRolYetkiYerleri() {
      let data = {
        Rol_rowid: this.SelectedRol_rowid
      }
      GlobalServis.GlobalServis("POST", "GetRolYetkiYeriTablosu", data).then((res) => {
        if (res.status == 200) {
          this.YetkiYerleriListesi = res.data;
        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    _UpdateRolYetkiYerleri(Durum) {
      let data = {
        Rol_rowid: this.SelectedRol_rowid,
        YetkiYeri_rowid: this.YetkiYeri_rowid,
        Durum: Durum
      }
      GlobalServis.GlobalServis("POST", "UpdateRolYetki", data).then((res) => {
        if (res.status == 200) {
          this.YetkiYerleriListesi = res.data;
          this.$toast.add({
            severity: "success",
            summary: "Başarılı",
            detail: "Yetki işlemi tamamlanmıştır.",
            life: 3000,
          });
          this._YetkiModal();
          this.Refresh();
        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    getDataChild(getdata_child) {
      this.YetkiPopUpDurumu = false;
      this.YetkiModal = !this.YetkiModal;
      this.YetkiYeri_rowid = getdata_child.data.YetkiYeri_rowid

      if (getdata_child.data.Durum == "Yetkili") {
        this.YetkilendirButton = true;
        this.YetkiKaldirButton = false;
      }
      else if (getdata_child.data.Durum == "Yetkisiz") {
        this.YetkilendirButton = false;
        this.YetkiKaldirButton = true;
      }
    },
    _YetkiModal() {
      this.YetkiModal = !this.YetkiModal;
      if (!this.YetkiModal) {
        // this.resetForm();
      }
    },
    Yetkilendir() {
      this._UpdateRolYetkiYerleri("0");
    },
    YetkiKaldir() {
      this._UpdateRolYetkiYerleri("1");
    },
    Refresh() {
      this.DataTable_render = false;
      this.$nextTick(() => {
        // this.InitServis();
        this._GetRolYetkiYerleri();
        this.DataTable_render = true;
      });
    },
  },
  mounted() {
    this.InitService();
    this._GetRolYetkiYerleri();

  },
  components: {
    DataTable
  },
};
</script>

<style lang="scss" scoped></style>
